import blog from './blog.json';
import contacts from './contacts.json';
import wheelTurningMachines from './wheel-turning-machines.json';
import machine32 from './mks-83.json';
import machine33 from './mks-83-2.json';
import machine34 from './mkst-83.json';
import machine35 from './mks-192.json';
import machine36 from './sks-83-2.json';
import machine37 from './sks-83-3.json';
import machine38 from './sks-83-1.json';
import machine39 from './sks-83-4.json';

export default {
    blog, 
    contacts, 
    wheelTurningMachines, 
    machine32, 
    machine33, 
    machine34, 
    machine35, 
    machine36, 
    machine37, 
    machine38, 
    machine39
};